module.exports = __webpack_public_path__ + "static/media/etat-repas-grey.df963637.svg";